export type TRoute = {
  ROUTE: string;
  NAME: string;
  TBLANK?: boolean;
};

type TRoutes = {
  [key: string]: TRoute;
};

const ROUTES: TRoutes = {
  MAIN: {
    ROUTE: '/main',
    NAME: 'Главная',
  },
  TESTS: {
    ROUTE: '/tests',
    NAME: 'Тесты',
  },
  TASKS: {
    ROUTE: '/tasks',
    NAME: 'Задания',
  },
  GAMES: {
    ROUTE: '/games',
    NAME: 'Игры',
  },
  PROFILE: {
    ROUTE: '/profile',
    NAME: 'Профиль',
  },
  PROFILE_INFORMATION: {
    ROUTE: '/profile/information',
    NAME: 'Персональные данные',
  },
  PROFILE_QUESTIONNAIRE: {
    ROUTE: '/profile/questionnaire',
    NAME: 'Анкета респондента',
  },
  PROFILE_GRADE: {
    ROUTE: '/profile/grade',
    NAME: 'Мой грейд',
  },
  PROFILE_FRIENDS: {
    ROUTE: '/profile/friends',
    NAME: 'Мои друзья в играх',
  },
  BALANCE: {
    ROUTE: '/balance',
    NAME: 'Баланс',
  },
  REGISTRATION: {
    ROUTE: '/registration',
    NAME: 'Регистрация',
  },
  MORE: {
    ROUTE: '/more',
    NAME: 'Еще',
  },
  TESTS_DEMO: {
    ROUTE: '/tests/demo/',
    NAME: 'Демо тесты',
  },
  TESTS_DEMO_ITEM: {
    ROUTE: '/tests/demo/:id',
    NAME: 'Демо тест:',
  },
  START: {
    ROUTE: '/start',
    NAME: 'Сложность',
  },
  PLAY: {
    ROUTE: '/plays',
    NAME: 'Игра',
  },
  LEADERS: {
    ROUTE: '/leaders',
    NAME: 'Лидеры',
  },
  FRIENDS: {
    ROUTE: '/friends',
    NAME: 'Друзья',
  },
  SHOP: {
    ROUTE: '/shops',
    NAME: 'Магазин',
  },
  SETTINGS: {
    ROUTE: '/settings',
    NAME: 'Настройки',
  },
  LOGIN: {
    ROUTE: '/login',
    NAME: 'Вход',
  },
  WEB_LOGIN: {
    ROUTE: '/web-login',
    NAME: 'Вход',
  },
  POLLS: {
    ROUTE: '/polls',
    NAME: 'Тесты',
  },
  POLL: {
    ROUTE: '/polls/:id',
    NAME: 'Тест',
  },
  INVITE: {
    ROUTE: '/invite',
    NAME: 'Приглашение собственного респондента',
  },
  CABINET_NEW_TEST: {
    ROUTE: '/new',
    NAME: 'Новый тест',
  },
  CABINET_EDIT: {
    ROUTE: '/edit',
    NAME: 'Редактировать',
  },
};

export default ROUTES;
